import { useMemo } from 'react';
import type { CurrencyDto } from '@shared/api/contracts';
import { buildReconciliationAssetNetworkOptions } from '../lib/asset-network-filter-options';

export function useReconciliationAssetNetworkOptions(currencies: CurrencyDto[]) {
  return useMemo(() => buildReconciliationAssetNetworkOptions(currencies), [currencies]);
}
